import React, { useState, useEffect } from "react";
import { auth, firestore } from "../utils/firebase";

function AdminContent({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isBusy, setIsBusy] = useState(true);
  //console.log("isAd check");

  useEffect(() => {
    if (auth.currentUser) {
      //console.log("check ",auth.currentUser.uid);
      firestore
        .collection("users")
        .doc(auth.currentUser.uid)
        .get()
        .then((data) => {
          if(data.data() && data.data()?.admin)
          {
            setIsAdmin(true);
          }else{
            setIsAdmin(false);
          }
        });
    }
    setIsBusy(false);
  }, [auth.currentUser]);

  if (!isBusy && isAdmin) {
    return <>{children}</>;
  } else {
    return <></>;
  }
}

export default AdminContent;
